export default __webpack_public_path__ + "4e45bbfb758d1ac68cab321920b253dc.png";